import axios from 'axios';

// axios.defaults.withCredentials = true
const openApi = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
    headers: {
      'AppKey': process.env.VUE_APP_API_KEY,
      "Content-Type": "application/json"
    }
})

openApi.interceptors.request.use(config => {
  config.headers.common['dusertoken'] = localStorage.getItem('dUserToken') === null ? '' : localStorage.getItem('dUserToken');
  return config
}, error => {
  return Promise.reject(error)
})
  
// response interceptor
openApi.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    const { response } = error
    return response ? response.data : Promise.reject(error)
  }
)

  
export { openApi }